import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import { HashRouter as Switch, Route, Routes, BrowserRouter } from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";

import IndexPage from './screens/static/index';
import Login from './screens/auth/login';
import ChangePassword from './screens/auth/changePassword';
import CompanyProfile from "./screens/static/registration/company-profile";
import BuisnessDetails from "./screens/static/registration/buisness-details";
import Payment from "./screens/static/registration/payment";
import India_itme_society from "./screens/static/about/india_itme_society";
import Itme_trade_services from "./screens/static/about/itme_trade_services";
import Why_india from "./screens/static/about/why_india";
import Trade_mission from "./screens/static/services/trade_mission";
import Knowledge_session from "./screens/static/services/knowledge_session";
import International_exhibition from "./screens/static/services/international_exhibition";
import Trade_enquiry from "./screens/static/services/trade_enquiry";
import Photo_gallery from "./screens/static/news/photo_gallery";
import Video_gallery from "./screens/static/news/video_gallery";
import Media_coverage from "./screens/static/news/media_coverage";
import Press_release from "./screens/static/news/press_release";
import Media_kit from "./screens/static/news/media_kit";
import ContactUS from "./screens/static/contact_us";
//admin module
import User_list from "./screens/admin/users/user_list";
import User_details from "./screens/admin/users/user_details";
import Proforma_list from "./screens/account/proforma/proforma_list";
import Taxinvoice_list from "./screens/account/taxInvoice/taxinvoice_list";
import CustomCursor from "./common_components/customCursor";
import Enquiry_form from "./screens/static/registration/enquiry_form";
import Thankyou from "./screens/static/registration/thanks";
import ReceiptList from "./screens/admin/receipt/receiptList";
import ReceiptAU from "./screens/admin/receipt/receiptAU";
// import Login from "./screens/registration/login";
import Dashboard from "./screens/dashboard/dashboard";
import TermsAndCondition from "./screens/static/termsAndCondition";
import PrivacyPolicy from "./screens/static/privacyPolicy";
import Enquiry_list from "./screens/admin/enquiry/enquiry_list";
import BenefitsList from "./screens/user/benefits/benefits_list";
import Role_list from "./screens/admin/role/role_list";
import Role_detail from "./screens/admin/role/role_detail";
import Cart from "./screens/user/cart/cart";
import PromoCode_list from "./screens/admin/promoCode/promoCode_list";
import PromoCode_detail from "./screens/admin/promoCode/promoCode_detail";
import BlogList from "./screens/admin/blog/blogList";
import BlogAU from "./screens/admin/blog/blogAU";
import Master_list from "./screens/admin/master/master_list";
import Master_detail from "./screens/admin/master/master_detail";
import BlogDetails from "./screens/static/blogDetails";
import MemberDashboard from "./screens/dashboard/memberDashboard";
import Event_enquiry_form from "./screens/static/registration/event_enquiry_form";
import Event_enquiry_list from "./screens/admin/enquiry/event_enquiry_list";
import Event_master_list from "./screens/admin/eventMaster/event_master_list";
import Event_master_detail from "./screens/admin/eventMaster/event_master_detail";
import RegisteredList from "./screens/static/registration/registeredList";
//cms routes
import CmsHome from "./screens/cms/cmsHome.js";
import CmsHeaderMaster from "./screens/cms/cmsHeaderMaster.js";
//report
import ReportList from "./screens/reports/reportList.js";
import ReportGenerator from "./screens/reports/reportGenerator";

function App() {
  // useEffect(() => {
  //   sessionStorage.setItem("renderPage", 'countrySelect')

  // }, [])

  return (
    <div className="App">
      <div className="auth-inner">
        {/* <CustomCursor /> */}
        <Switch>
          <Routes>
            <Route exact path="/" element={<IndexPage />} />
            <Route exact path="/:page" element={<IndexPage />} />
            {/* cms routes */}
            <Route exact path="/cms/manage" element={<CmsHome />} />
            <Route exact path="/cms/manage/:page" element={<CmsHome />} />
            <Route exact path="/cms/header" element={<CmsHeaderMaster />} />
            {/* report */}
            <Route exact path="/reportList" element={<ReportList />} />
            <Route exact path="/reportGenerator" element={<ReportGenerator />} />
            {/* static */}
            <Route exact path="/index" element={<IndexPage />} />
            <Route exact path="/companyProfile" element={<CompanyProfile />} />
            <Route exact path="/companyProfile/:id" element={<CompanyProfile />} />
            <Route exact path="/buisnessDetails" element={<BuisnessDetails />} />
            <Route exact path="/buisnessDetails/:id" element={<BuisnessDetails />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/changePassword" element={<ChangePassword />} />
            <Route exact path="/payment" element={<Payment />} />
            <Route exact path="/payment/:id" element={<Payment />} />
            <Route exact path="/indiaItmeSociety" element={<India_itme_society />} />
            <Route exact path="/RegisteredList" element={<RegisteredList />} />
            <Route exact path="/itmeTradeServices" element={<Itme_trade_services />} />
            <Route exact path="/whyEngageWithIndia" element={<Why_india />} />
            <Route exact path="/tradeMission" element={<Trade_mission />} />
            <Route exact path="/knowledgeSessions" element={<Knowledge_session />} />
            <Route exact path="/internationalExhibitions" element={<International_exhibition />} />
            <Route exact path="/tradeEnquiry" element={<Trade_enquiry />} />
            <Route exact path="/photoGallery" element={<Photo_gallery />} />
            <Route exact path="/videoGallery" element={<Video_gallery />} />
            <Route exact path="/mediaCoverage" element={<Media_coverage />} />
            <Route exact path="/pressRelease" element={<Press_release />} />
            <Route exact path="/mediaKit" element={<Media_kit />} />
            <Route exact path="/contactUS" element={<ContactUS />} />
            <Route exact path="/enquiryForm" element={<Enquiry_form />} />
            <Route exact path="/eventEnquiryForm" element={<Event_enquiry_form />} />
            <Route exact path="/thankyou" element={<Thankyou />} />
            <Route exact path="/thankyou/:id" element={<Thankyou />} />
            {/* admin module */}
            <Route exact path="/user_list" element={<User_list />} />
            <Route exact path="/user_details" element={<User_details />} />
            <Route exact path="/proforma_list" element={<Proforma_list />} />
            <Route exact path="/taxInvoice_list" element={<Taxinvoice_list />} />
            <Route exact path="/event_enquiry_list" element={<Event_enquiry_list />} />
            <Route exact path="/enquiry_list" element={<Enquiry_list />} />
            <Route exact path="/role_list" element={<Role_list />} />
            <Route exact path="/role_details" element={<Role_detail />} />
            <Route exact path="/promocode_list" element={<PromoCode_list />} />
            <Route exact path="/promocode_detail" element={<PromoCode_detail />} />
            <Route exact path="/master_list" element={<Master_list />} />
            <Route exact path="/master_detail" element={<Master_detail />} />
            <Route exact path="/event_master_list" element={<Event_master_list />} />
            <Route exact path="/event_master_detail" element={<Event_master_detail />} />
            {/* account module */}
            <Route exact path="/receiptList" element={<ReceiptList />} />
            <Route exact path="/receiptAU" element={<ReceiptAU />} />
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/termsAndCondition" element={<TermsAndCondition />} />
            <Route exact path="/privacyPolicy" element={<PrivacyPolicy />} />
            {/* user module */}
            <Route exact path="/benefits_list" element={<BenefitsList />} />
            {sessionStorage.getItem("isPgButton") == 1 && (<>
              <Route exact path="/cart" element={<Cart />} />
              <Route exact path="/cart/:status" element={<Cart />} />
            </>)}
            <Route exact path="/blogList" element={<BlogList />} />
            <Route exact path="/blogAU" element={<BlogAU />} />
            <Route exact path="/blogDetails/:id" element={<BlogDetails />} />
            <Route exact path="/blogDetails" element={<BlogDetails />} />
            <Route exact path="/memberDashboard" element={<MemberDashboard />} />
          </Routes>
        </Switch>
      </div>
    </div>
  );
}

export default App;
